module.exports = __webpack_public_path__ + "img/template-08.337743aa.jpg";